import { 
  doc, 
  getDoc, 
  setDoc,
  updateDoc,
  Timestamp 
} from 'firebase/firestore';
import { db } from '../firebase';

const USER_SETTINGS_COLLECTION = 'user_settings';

export const UserSettingsService = {
  // Get user settings
  getUserSettings: async (userId, settingsType = 'general') => {
    console.log('getUserSettings called with userId:', userId, 'settingsType:', settingsType);
    if (!userId) {
      console.error('No userId provided to getUserSettings');
      return null;
    }

    const settingsRef = doc(db, USER_SETTINGS_COLLECTION, userId);
    const settingsDoc = await getDoc(settingsRef);
    
    if (!settingsDoc.exists()) {
      // Initialize with default settings
      const defaultSettings = {
        general: {
          theme: 'light',
          language: 'en',
          lastUpdated: Timestamp.now()
        },
        pricing: {
          minimumPrice: '0,95',
          fixedAmount: '2,3',
          margin: '60',
          salesPriceFactor: '2.3',
          roundingValue: '0.95',
          compareFactor: '50',
          priceChange: '10',
          priceChangeType: 'increase',
          selectedPriceField: 'price',
          lastUpdated: Timestamp.now()
        },
        inventory: {
          inventory_quantity: '10',
          ignoreZero: ['yes'],
          lastUpdated: Timestamp.now()
        },
        product: {
          prefix: '',
          suffix: '',
          vendorName: '',
          lastUpdated: Timestamp.now()
        }
      };
      
      await setDoc(settingsRef, defaultSettings);
      return defaultSettings[settingsType] || {};
    }
    
    const data = settingsDoc.data();
    return data[settingsType] || {};
  },

  // Save user settings
  saveUserSettings: async (userId, settingsType, settings) => {
    console.log('saveUserSettings called with userId:', userId, 'settingsType:', settingsType, 'settings:', settings);
    if (!userId) {
      console.error('No userId provided to saveUserSettings');
      return false;
    }

    try {
      const settingsRef = doc(db, USER_SETTINGS_COLLECTION, userId);
      const settingsDoc = await getDoc(settingsRef);
      
      if (!settingsDoc.exists()) {
        // Create new document with settings
        const newSettings = {
          [settingsType]: {
            ...settings,
            lastUpdated: Timestamp.now()
          }
        };
        await setDoc(settingsRef, newSettings);
      } else {
        // Update existing document
        await updateDoc(settingsRef, {
          [`${settingsType}`]: {
            ...settings,
            lastUpdated: Timestamp.now()
          }
        });
      }
      
      console.log(`User settings saved for ${userId}:`, settings);
      return true;
    } catch (error) {
      console.error('Error saving user settings:', error);
      return false;
    }
  }
};

export default UserSettingsService;
